import styled from "styled-components";

export const GhostWrap = styled.div`
  .loading {
    height: 500px;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;

    p {
      position: relative;
      font-variant: small-caps;
      font-size: 3em;
      letter-spacing: 4px;
      overflow: hidden;
      background: linear-gradient(
        90deg,
        var(--color-active-primary),
        var(--color-background),
        var(--color-active-primary)
      );
      background-repeat: no-repeat;
      background-size: 80%;
      animation: spinner 1s linear infinite;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: rgba(255, 255, 255, 0);
    }
  }

  @keyframes spinner {
    0% {
      background-position: -800%;
    }
    100% {
      background-position: 800%;
    }
  }
`;
